import {AfterViewInit, Component, ElementRef} from '@angular/core';

@Component({
    selector: 'app-i18n-dictionary',
    template: '<ng-content></ng-content>'
})
export class I18nDictionaryComponent implements AfterViewInit {

    private translations: { [id: string]: string; } = {};

    constructor(private elementRef: ElementRef) {
    }

    get(id): string {
        return this.translations[id];
    }

    ngAfterViewInit(): void {
        const nativeElement = this.elementRef.nativeElement;
        const elements = nativeElement.getElementsByTagName('span');
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];

            element.setAttribute('style', 'display:none; visibility:hidden;');
            const transId = element.getAttribute('transid');
            this.translations[transId] = '' === element.innerHTML ? '[i18n => ' + transId + ']' : element.innerHTML;
        }

        while (nativeElement.hasChildNodes()) {
            nativeElement.removeChild(nativeElement.childNodes[0]);
        }
    }
}
